import React, { useState, useEffect } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, CircularProgress, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Typography, TablePagination } from '@mui/material';
import { getFirestore, collection, query, where, getDocs } from 'firebase/firestore';

const MonthlyHoursDialog = ({ open, onClose, user }) => {
  const [monthlyHours, setMonthlyHours] = useState([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const db = getFirestore();

  useEffect(() => {
    if (open && user) {
      const fetchMonthlyHours = async () => {
        setLoading(true);
        try {
          const monthlyHoursRef = collection(db, 'employeeMonthlyHours');
          const q = query(monthlyHoursRef, where('employeeId', '==', user.id));
          const querySnapshot = await getDocs(q);

          const hoursData = querySnapshot.docs.map(doc => ({
            ...doc.data(),
            id: doc.id
          }));

          setMonthlyHours(hoursData);
        } catch (error) {
          console.error('Error fetching monthly hours:', error);
        } finally {
          setLoading(false);
        }
      };

      fetchMonthlyHours();
    }
  }, [open, user, db]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const formatDate = (timestamp) => {
    try {
      const date = new Date(timestamp);
      return date.toLocaleDateString(); // Adjust formatting as needed
    } catch (error) {
      console.error('Error formatting date:', error);
      return 'Invalid date';
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>Monthly Hours {user.id} - {user.name}</DialogTitle>
      <DialogContent>
        {loading ? (
          <CircularProgress />
        ) : monthlyHours.length > 0 ? (
          <TableContainer elevation={0} component={Paper}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell><b>Month</b></TableCell>
                  <TableCell><b>Hours</b></TableCell>
                  <TableCell><b>Calculation Date</b></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {monthlyHours.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map(({ id, month, monthlyHours, timestamp }) => (
                  <TableRow key={id}>
                    <TableCell>{month}</TableCell>
                    <TableCell>{monthlyHours} hours</TableCell>
                    <TableCell>{formatDate(timestamp)}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
            <TablePagination
              rowsPerPageOptions={[5, 10, 25]}
              component="div"
              count={monthlyHours.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </TableContainer>
        ) : (
          <Typography variant="body1">No monthly hours available for this employee.</Typography>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default MonthlyHoursDialog;
